import { render, staticRenderFns } from "./StudentElectiveEnrollment.vue?vue&type=template&id=3a2f4312"
import script from "./StudentElectiveEnrollment.vue?vue&type=script&lang=js"
export * from "./StudentElectiveEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports